export default class TimeOutError extends Error {}
